import { BreadcrumbComponentModule } from './../../_component/breadcrumb/breadcrumb.module';
import { SharedDirectivesModule } from './../../../_directives/shared-directives.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { CartPageRoutingModule } from './cart-routing.module';
import { CartPage } from './cart.page';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    CartPageRoutingModule,
    TranslateModule,
    SharedDirectivesModule,
    BreadcrumbComponentModule
  ],
  declarations: [CartPage],
  providers: [
    Window
  ], 
})
export class CartPageModule {}
